<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item label="订单号">
            <el-input
              v-model="form.orderId"
              placeholder="请输入订单号"
              style="width: 260px"
              class="inputOrderId"
              @input="val => handleInput(val)"
              @select="val => handleSelect(val)"
            ></el-input>
            <div class="inputStyle" v-html="orderInputId"></div>
          </el-form-item>
          <el-form-item
            v-if="
              $store.state.roleId == '1070960390067716097' ||
              $store.state.roleId == '2125410685723869666'
            "
            label="商户"
          >
            <el-select
              v-model="form.appId"
              placeholder="请选择"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="冻结类型">
            <el-select
              v-model="form.freezeType"
              style="width: 100px"
              placeholder="请选择"
            >
              <el-option label="订单" value="00"></el-option>
              <el-option label="手动" value="01"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="冻结状态">
            <el-select
              v-model="form.freezeStatus"
              style="width: 120px"
              placeholder="请选择"
            >
              <el-option label="已解冻" value="00"></el-option>
              <el-option label="已冻结" value="01"></el-option>
              <el-option label="已退款" value="02"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="buttonArea">
          <el-button type="primary" @click="addFrozen" size="small">
            手动冻结</el-button
          >
        </template>
        <template slot="tableColumn">
          <el-table-column
            prop="orderId"
            width="330px"
            label="订单号"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="orderStyle" style="margin-bottom: 0px; float: left">
                <el-tag size="mini">平台</el-tag>{{ row.orderId }}
              </div>
              <br />
              <div class="orderStyle" style="margin-bottom: 0px; float: left">
                <el-tag size="mini" type="success">商户</el-tag
                >{{ row.merchantOrderId }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="140"
            prop="orderId"
            label="商户"
            align="center"
          >
            <template slot-scope="{ row }">
              <div>{{ row.appId }}</div>
              <div>{{ row.merchantName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="freezeType"
            label="冻结类型"
            align="center"
            width="80px"
          >
            <template slot-scope="{ row }">
              <el-tag
                size="small"
                :type="row.freezeType == '00' ? 'warning' : 'primary'"
                >{{ row.freezeType == '00' ? '订单' : '手动' }}</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
            width="80px"
            prop="freezeStatus"
            :formatter="$formatter.formatFreezeStatus"
            label="冻结状态"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="80px"
            prop="orderRefund"
            :formatter="$formatter.formatYesNo"
            label="扣减商户"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="amount"
            :formatter="$formatter.FenToYuan"
            label="冻结金额"
            align="center"
            width="100px"
          >
          </el-table-column>

          <el-table-column
            width="160px"
            prop="freezeTimeStr"
            label="冻结时间"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="220px"
            prop="freezeRemark"
            label="冻结备注"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="160"
            prop="unfreezeTimeStr"
            label="解冻时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="220px"
            prop="unfreezeRemark"
            label="解冻备注"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="140px"
            prop="contactInfo"
            label="联系邮箱"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="140px"
            prop="refundAmount"
            :formatter="$formatter.FenToYuan"
            label="退款金额"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="160"
            prop="refundTimeStr"
            label="退款时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="120px"
            prop="refundRemark"
            label="退款备注"
            align="center"
          >
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  $store.state.roleId == '1070960390067716097' &&
                  scope.row.freezeStatus == '01'
                "
                type="warning"
                size="mini"
                plain
                @click="handleModify(scope.row)"
                >解冻
              </el-button>
              <el-button
                v-if="
                  $store.state.roleId == '1070960390067716097' &&
                  scope.row.freezeStatus == '00'
                "
                type="success"
                size="mini"
                plain
                @click="handleModify(scope.row)"
                >冻结
              </el-button>

              <el-button
                v-if="
                  $store.state.roleId == '1070960390067716097' &&
                  scope.row.freezeStatus == '01' &&
                  scope.row.freezeType == '00'
                "
                type="warning"
                size="mini"
                plain
                @click="handleCashRefund(scope.row)"
                >款项退回
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>
    </div>

    <frozen
      :is-show-frozen-dialog.sync="isShowFrozenDialog"
      :id="id"
      :item="item"
    ></frozen>

    <AddFronzen
      :show.sync="showDialog"
      :merchant-list="merchantList"
    ></AddFronzen>

    <CashRefund
      :is-show-refund-dialog.sync="isShowRefundDialog"
      :id="id"
      :item="item"
    ></CashRefund>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
import moment from 'moment'
import frozen from './components/frozen'
import AddFronzen from './AddFronzen'
import CashRefund from './components/cashRefund'

export default {
  components: {
    page: Page,
    frozen,
    AddFronzen,
    CashRefund,
  },
  data() {
    return {
      url: '/freezeBalance/selectList',
      merchantList: [],
      agentList: [],
      orderInputId: '',
      form: {
        orderId: '',
        appId: '',
        freezeType: '',
        freezeStatus: '',
      },
      timeDate: [],
      isShowFrozenDialog: false,
      id: '',
      item: {},
      showDialog: false,
      isShowRefundDialog: false,
    }
  },
  methods: {
    handleModify(row) {
      this.id = row.id
      this.isShowFrozenDialog = true
      this.item = row
    },

    handleCashRefund(row) {
      this.id = row.id
      this.isShowRefundDialog = true
      this.item = row
    },

    addFrozen() {
      this.showDialog = true
    },
    reset() {
      this.orderInputId = ''
    },
    handleInput(val) {
      if (val.indexOf('2023') > -1) {
        let length = val.indexOf('2023')
        let str = val.split('2023')
        if (str[1].length >= 4) {
          let sub = val.substring(length, length + 8)
          let value = val.split(sub)
          this.orderInputId = `${value[0]}<span style="color:#E6A23C">${sub}</span>${value[1]}`
        } else {
          this.orderInputId = val
        }
      } else {
        this.orderInputId = val
      }
    },
    handleSelect(val) {
      console.log(11111111111)
    },
  },
  created() {
    if (this.$route.query.orderId) {
      this.form.orderId = this.$route.query.orderId
      this.$bus.$emit('refresh')
    }
    this.$axios
      .get('/merchant/selectListForOption', { params: {} })
      .then(res => {
        this.merchantList = res.data
      })
  },
}
</script>
<style lang="scss" scoped>
.el-form-item__content {
  position: relative;
}
.inputStyle {
  position: absolute;
  top: 0;
  left: 0;
  // width: 100%;
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 13px;
  pointer-events: none;
  color: #606266;
}

::v-deep .inputOrderId {
  position: relative;
  z-index: 1;
  .el-input__inner {
    color: transparent;
    background-color: transparent;
    caret-color: #606266;
  }
}
</style>